import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]


import { Brand } from '../../services/integration/enums';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';


export default /*#__PURE__*/_defineComponent({
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: false },
    centered: { type: Boolean, required: false }
  },
  setup(__props: any) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[{'text-center': __props.centered}, _unref(brandService).getName() === _unref(Brand).HIS ? 'text-brand-secondary' : 'text-black' ], "text-black"])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'font-gotham-bold' : 'font-extrabold', "leading-none text-2xl md:text-3xl lg:text-5xl tracking-tight"])
    }, _toDisplayString(__props.title), 3),
    (__props.subtitle)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "text-md md:text-xl max-w-2xl text-gray-500 font-light",
          innerHTML: __props.subtitle
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})